<template>
  <CDropdown 
    :caret="false"
    placement="bottom-end"
    in-nav
    class="c-header-nav-item mx-2 d-md-down-none"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <CIcon name="cil-speech"/>
        <CBadge shape="pill" color="info">{{configureNumber()}}</CBadge>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center bg-light">
      <strong>{{configureNumber()}} unread messages</strong>
      <div style="width:100%;padding-top:5px;">
        <CButton size="sm" color="danger" @click="removeRead()">Remove Read</CButton>
        <CButton size="sm" color="danger" style="margin-left:5px;" @click="removeAll()">Remove All</CButton>
      </div>
    </CDropdownHeader>
    <CDropdownItem class="itemMessage" :class="val.read_at ? 'read' : ''" v-if="$store.state.messages" v-for="val in $store.state.messages" @click="goToOrder(val)">
      <div class="message" style="width:500px;">
        <div>
          <small class="text-muted">From: {{val.user.name}}</small>
          <small class="text-muted float-right mt-1">{{val.local_created_at}}</small>
        </div>
        <div class="text-truncate font-weight-bold">
          <!-- <CIcon name="cil-warning" class="text-danger"/>  -->
          {{val.text}}
        </div>
        <!-- <div class="small text-muted text-truncate">{{val.text}}</div> -->
      </div>
    </CDropdownItem>
    <!-- <CDropdownItem 
      href="#" 
      class="border-top text-center"
    >
      <strong>View all messages</strong>
    </CDropdownItem> -->
  </CDropdown>
</template>
<script>
var methods = {}

methods.goToOrder = function (val) {
  val.read_at = true
  this.$router.push('/order/' + val.order_id + '/' + val.order_group_id)
}

methods.removeRead = function () {
  axios.post(this.$apiAdress + '/api/chat/removeRead?token=' + localStorage.getItem('api_token')).then(response => {
    // this.messages = response.data
    this.$store.commit('setMessages', response.data)
  })
}
methods.removeAll = function () {
  axios.post(this.$apiAdress + '/api/chat/removeAll?token=' + localStorage.getItem('api_token')).then(response => {
    // this.messages = response.data
    this.$store.commit('setMessages', response.data)
  })
}

methods.getMessages = function () {
  axios.get(this.$apiAdress + '/api/chat/getMessages?token=' + localStorage.getItem('api_token'))
  .then(response => {
    console.log('messages')
    console.log(response)
    // this.messages = response.data
    this.$store.commit('setMessages', response.data)
    this.$forceUpdate()
  })
}

methods.configureNumber = function () {
  var t = 0
  if (this.$store.state.messages && this.$store.state.messages.length) {
    this.$store.state.messages.forEach(function (val) {
      if (!val.read_at) {
        t++
      }
    })
  }
  return t
}

export default {
  name: 'TheHeaderDropdownMssgs',
  data () {
    return { 
      messages: []
    }
  },
  mounted: function () {
    this.getMessages()
  },
  methods: methods
}
</script>
<style lang="scss" scoped>
.itemMessage {
  &:hover {
    background-color:#e0e0e0;
  }
}
.read {
  background-color:#e0e0e0;

  &:hover {
    background-color:#cccccc;
  }
}
</style>
